import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  max-height: 100%;
  overflow-y: auto;
  width: 100%;
  word-wrap: break-word;

  a {
    width: fit-content;
    word-break: break-word;
  }
`;

export const Instructions = styled.div`
  margin-top: 20px;
`;

export const InstructionsContent = styled.p`
  white-space: pre-wrap;
`;

export const Bold = styled.span`
  font-weight: 500;
`;
